/**
 * LoadingIndicator Component
 * Reusable loading indicator with spinner
 */
import '../styles/LoadingIndicator.css'

export default function LoadingIndicator({ message = 'Loading...', show = true }) {
  if (!show) return null

  return (
    <div className="loading-indicator">
      <div className="loading-spinner" />
      {message}
    </div>
  )
}
